(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-bottle-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REVIEW_TARGETS = [
      '#collection-review-carousel',
      '.jdgm-all-reviews-widget',
      '#judgeme_all_reviews_page',
      '.jdgm-rev-widget',
      '#judgeme_product_reviews',
      '.jdgm-widget'
    ];

    function scrollToReviews(e) {
      for (var i = 0; i < REVIEW_TARGETS.length; i++) {
        var el = document.querySelector(REVIEW_TARGETS[i]);
        if (el && el.offsetParent !== null) {
          e.preventDefault();
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
      }
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
    // "HARLAND (Green)" and "harland green" are the same print.
    function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
    function title(s) { return String(s || '').replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); }); }

    function init(root) {
      if (!root || root.dataset.cbbReady) return;
      root.dataset.cbbReady = '1';

      Array.prototype.forEach.call(root.querySelectorAll('[data-reviews-link]'), function (a) {
        a.addEventListener('click', scrollToReviews);
      });

      var prefix = root.getAttribute('data-money-prefix') || '$';
      var suffix = root.getAttribute('data-money-suffix') || '';
      var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;
      var addUrl = root.getAttribute('data-cart-add');
      var cartUrl = root.getAttribute('data-cart-url');
      var unitOne = root.getAttribute('data-unit-one') || 'piece';
      var unitMany = root.getAttribute('data-unit-many') || 'pieces';
      var upsellPrice = parseInt(root.getAttribute('data-upsell-price'), 10) || 0;
      var upsellName = root.getAttribute('data-upsell-name') || '';
      var upsellHref = root.getAttribute('data-upsell-href') || '';
      var upsellText = root.getAttribute('data-upsell-text') || '';

      var panel = root.querySelector('[data-nc-panel]');
      var pk = panel ? {
        id: panel.getAttribute('data-variant'),
        price: parseInt(panel.getAttribute('data-price'), 10) || 0,
        name: panel.getAttribute('data-name'),
        img: panel.getAttribute('data-img'),
        jacketProp: panel.getAttribute('data-jacket-prop'),
        tileProp: panel.getAttribute('data-tile-prop')
      } : null;

      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
      var lowest = cards.reduce(function (m, c) {
        if (c.getAttribute('data-kind') !== 'jacket') return m;
        var p = parseInt(c.getAttribute('data-price'), 10) || 0;
        return p && (!m || p < m) ? p : m;
      }, 0);

      // One line per product (per print pair, for a set chosen in the panel),
      // each with its own quantity.
      var lines = [];

      function each(sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }
      function money(cents) { return prefix + (cents / 100).toFixed(2) + suffix; }
      function find(key) { for (var i = 0; i < lines.length; i++) { if (lines[i].key === key) return lines[i]; } return null; }
      function qtyOf(handle) { return lines.reduce(function (a, l) { return a + (l.handle === handle ? l.qty : 0); }, 0); }
      function change(key, d) {
        var l = find(key);
        if (!l) return;
        l.qty += d;
        if (l.qty <= 0) lines.splice(lines.indexOf(l), 1);
        render();
      }

      function addCard(card) {
        var key = card.getAttribute('data-handle');
        var l = find(key);
        if (l) l.qty += 1;
        else lines.push({
          key: key,
          kind: card.getAttribute('data-kind') || 'jacket',
          handle: key,
          name: card.getAttribute('data-name'),
          desc: card.getAttribute('data-desc'),
          price: parseInt(card.getAttribute('data-price'), 10) || 0,
          img: card.getAttribute('data-img'),
          std: card.getAttribute('data-std'),
          slim: card.getAttribute('data-slim'),
          fit: 'STANDARD',
          qty: 1
        });
        render();
      }

      function render() {
        var count = lines.reduce(function (a, l) { return a + l.qty; }, 0);
        var total = lines.reduce(function (a, l) { return a + l.price * l.qty; }, 0);
        var onlyJackets = lines.every(function (l) { return l.kind === 'jacket'; });
        var word = function (n) { return onlyJackets ? (n === 1 ? unitOne : unitMany) : (n === 1 ? 'item' : 'items'); };

        each('[data-set]', function (set) {
          set.innerHTML = '';
          if (!count) {
            var p = document.createElement('p');
            p.className = 'cbb__empty';
            p.textContent = root.getAttribute('data-empty') || '';
            set.appendChild(p);
          }
          lines.forEach(function (l) {
            var row = document.createElement('div');
            row.className = 'cbb__piece';
            row.innerHTML = '<img src="' + esc(l.img) + '" alt=""><span><span class="cbb__piece-name">' + esc(l.name) + '</span>' +
              (l.desc ? '<span class="cbb__piece-desc">' + esc(l.desc) + '</span>' : '') +
              '<span class="cbb__piece-controls"></span></span><span class="cbb__piece-price">' + money(l.price * l.qty) + '</span>';
            var controls = row.querySelector('.cbb__piece-controls');
            // Only a set with a Can Couture sleeve has a fit. A jacket is one size.
            if (l.slim && l.std) {
              var sw = document.createElement('span');
              sw.className = 'cbb__switch';
              ['STANDARD', 'SLIMLINE'].forEach(function (opt) {
                var b = document.createElement('button');
                b.type = 'button';
                b.className = 'cbb__switch-btn';
                b.innerHTML = opt === 'STANDARD' ? 'Standard<small>375 ml</small>' : 'Slimline<small>250–330 ml</small>';
                b.setAttribute('aria-pressed', String(l.fit === opt));
                b.addEventListener('click', function () { if (l.fit !== opt) { l.fit = opt; render(); } });
                sw.appendChild(b);
              });
              controls.appendChild(sw);
            }
            var q = document.createElement('span');
            q.className = 'cbb__qty';
            q.innerHTML = '<button type="button" aria-label="' + (l.qty === 1 ? 'Remove ' : 'One fewer ') + esc(l.name) + '">' + (l.qty === 1 ? '&times;' : '&minus;') + '</button>' +
              '<output aria-live="polite">' + l.qty + '</output>' +
              '<button type="button" aria-label="One more ' + esc(l.name) + '">+</button>';
            q.children[0].addEventListener('click', function () { change(l.key, -1); });
            q.children[2].addEventListener('click', function () { change(l.key, 1); });
            controls.appendChild(q);
            set.appendChild(row);
          });
        });

        cards.forEach(function (card) {
          var n = qtyOf(card.getAttribute('data-handle'));
          card.setAttribute('aria-pressed', String(n > 0));
          card.querySelector('.cbb__pick').innerHTML = n ? (n > 1 ? String(n) : '&#10003;') : '+';
        });

        var linesEl = root.querySelector('.cbb__lines');
        if (linesEl) linesEl.hidden = !count;
        root.querySelector('[data-count-label]').textContent = count + ' ' + word(count);
        root.querySelector('[data-subtotal]').textContent = money(total);
        root.querySelector('[data-total]').textContent = money(total);

        // The two AOV levers: the step up to a set, then the free-shipping line.
        var left = threshold > 0 ? threshold - total : 0;
        var nudge = '';
        var single = count === 1 && lines[0].kind === 'jacket' ? lines[0] : null;
        if (single && upsellText && upsellPrice > single.price) {
          var link = pk
            ? '<a href="#" data-upsell-open="' + esc(single.handle) + '">' + esc(upsellName) + '</a>'
            : (upsellHref ? '<a href="' + esc(upsellHref) + '">' + esc(upsellName) + '</a>' : esc(upsellName));
          nudge = esc(upsellText)
            .replace('[amount]', '<b>' + money(upsellPrice - single.price) + '</b>')
            .replace('[set]', link);
       } else if (false && count && left > 0 && lowest) {
          var need = Math.ceil(left / lowest);
          nudge = 'Add <b>' + need + ' more ' + (need === 1 ? unitOne : unitMany) + '</b> and shipping is on us.';
        }
        each('[data-nudge]', function (el) { el.innerHTML = nudge; });

        if (threshold > 0) {
          var shipText = left <= 0 ? 'Shipping is on us' : money(left) + ' to free shipping';
          each('[data-ship]', function (el) {
            el.textContent = shipText;
            el.classList.toggle('cbb__ship--met', left <= 0);
            el.style.display = (count > 0 && left <= 4000) ? '' : 'none';
          });
        }

        var label = count ? 'Add ' + count + ' ' + word(count) + ' to bag' : root.getAttribute('data-idle');
        each('[data-add], [data-add-mobile]', function (b) { b.disabled = !count; b.textContent = label; });

        root.querySelector('[data-tray]').hidden = !count;
        root.querySelector('[data-tray-label]').textContent = count + ' ' + word(count);
        root.querySelector('[data-tray-total]').textContent = money(total);

        each('[data-tier-kind]', function (el) {
          var kind = el.getAttribute('data-tier-kind');
          el.classList.toggle('is-on', lines.some(function (l) { return l.kind === kind; }));
        });
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () { addCard(card); });
      });

      // ---- The set panel ----
      var pick = { jacket: null, tiles: null };
      var swapFrom = '';
      var lastFocus = null;

      function paintPanel() {
        each('[data-nc-swatch]', function (sw) {
          var g = pick[sw.getAttribute('data-group')];
          sw.setAttribute('aria-pressed', String(!!g && g.value === sw.getAttribute('data-value')));
        });
        each('[data-nc-chosen]', function (el) {
          var g = pick[el.getAttribute('data-nc-chosen')];
          el.textContent = g ? g.label : '';
        });
        var btn = panel.querySelector('[data-nc-add]');
        var ready = pick.jacket && pick.tiles;
        btn.disabled = !ready;
        btn.textContent = btn.getAttribute(ready ? 'data-ready' : 'data-idle');
      }

      function openPanel(fromHandle) {
        if (!panel) return;
        pick = { jacket: null, tiles: null };
        swapFrom = '';
        // From the nudge, the jacket already chosen becomes the set's jacket.
        if (fromHandle) {
          var card = root.querySelector('[data-card][data-handle="' + fromHandle + '"]');
          var want = card ? norm(card.getAttribute('data-name')) : '';
          each('[data-nc-swatch][data-group="jacket"]', function (sw) {
            if (want && norm(sw.getAttribute('data-value')) === want) {
              pick.jacket = { value: sw.getAttribute('data-value'), label: sw.getAttribute('data-label') };
              swapFrom = fromHandle;
            }
          });
        }
        paintPanel();
        lastFocus = document.activeElement;
        panel.hidden = false;
        document.documentElement.classList.add('cbb-lock');
        var x = panel.querySelector('.cbb__nc-x');
        if (x) x.focus();
      }

      function closePanel() {
        if (!panel || panel.hidden) return;
        panel.hidden = true;
        document.documentElement.classList.remove('cbb-lock');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      if (panel) {
        each('[data-open-picker]', function (el) {
          el.addEventListener('click', function (e) { e.preventDefault(); openPanel(''); });
        });
        each('[data-nc-close]', function (el) { el.addEventListener('click', closePanel); });
        panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
        each('[data-nc-swatch]', function (sw) {
          sw.addEventListener('click', function () {
            pick[sw.getAttribute('data-group')] = { value: sw.getAttribute('data-value'), label: sw.getAttribute('data-label') };
            paintPanel();
          });
        });
        panel.querySelector('[data-nc-add]').addEventListener('click', function () {
          if (!pick.jacket || !pick.tiles) return;
          var key = 'set|' + pick.jacket.value + '|' + pick.tiles.value;
          var l = find(key);
          if (l) l.qty += 1;
          else {
            var props = {};
            if (pk.jacketProp) props[pk.jacketProp] = pick.jacket.value;
            if (pk.tileProp) props[pk.tileProp] = pick.tiles.value;
            lines.push({
              key: key,
              kind: 'nightcap',
              handle: '',
              name: pk.name,
              desc: title(pick.jacket.label) + ' jacket · ' + title(pick.tiles.label) + ' tiles',
              price: pk.price,
              img: pk.img,
              std: pk.id,
              slim: '',
              fit: 'STANDARD',
              qty: 1,
              props: props
            });
          }
          // Stepping up from the nudge: the single jacket becomes the set's jacket.
          if (swapFrom) {
            var j = find(swapFrom);
            if (j && norm(j.name) === norm(pick.jacket.value)) {
              j.qty -= 1;
              if (j.qty <= 0) lines.splice(lines.indexOf(j), 1);
            }
          }
          closePanel();
          render();
        });
      }

      root.addEventListener('click', function (e) {
        var up = e.target.closest ? e.target.closest('[data-upsell-open]') : null;
        if (up && panel) { e.preventDefault(); openPanel(up.getAttribute('data-upsell-open')); }
      });

      function addToCart() {
        var items = lines.map(function (l) {
          var id = l.fit === 'SLIMLINE' && l.slim ? l.slim : (l.std || l.slim);
          var item = { id: parseInt(id, 10), quantity: l.qty };
          if (l.props) item.properties = l.props;
          return item;
        }).filter(function (i) { return i.id; });
        if (!items.length) return;
        each('[data-add], [data-add-mobile]', function (b) { b.disabled = true; });
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = cartUrl;
        }).catch(function () {
          each('[data-add], [data-add-mobile]', function (b) { b.disabled = false; });
        });
      }

      var addBtn = root.querySelector('[data-add]');
      root.setAttribute('data-idle', addBtn ? addBtn.textContent.trim() : 'Add to bag');
      var empty = root.querySelector('.cbb__empty');
      root.setAttribute('data-empty', empty ? empty.textContent.trim() : '');
      each('[data-add], [data-add-mobile]', function (b) { b.addEventListener('click', addToCart); });

      render();
    }

    function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-cbb]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-cbb]');
      if (el) { delete el.dataset.cbbReady; init(el); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-set-builder"]) return;
  try {
    
  (function () {
    // The review widget is its own section further down the page, so the star
    // line looks for whichever of these the theme actually rendered.
    var REVIEW_TARGETS = [
      '#csb-reviews',
      '#collection-review-carousel',
      '.jdgm-all-reviews-widget',
      '#judgeme_all_reviews_page',
      '.jdgm-rev-widget',
      '#judgeme_product_reviews',
      '.jdgm-widget'
    ];

    function scrollToReviews(e) {
      for (var i = 0; i < REVIEW_TARGETS.length; i++) {
        var el = document.querySelector(REVIEW_TARGETS[i]);
        if (el && el.offsetParent !== null) {
          e.preventDefault();
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
      }
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
    function title(s) { return String(s || '').replace(/(^|[\s(])([a-zà-ÿ])/g, function (m, a, b) { return a + b.toUpperCase(); }); }

    function init(root) {
      if (!root || root.dataset.csbReady) return;
      root.dataset.csbReady = '1';

      var reviewLinks = root.querySelectorAll('[data-reviews-link]');
      for (var r = 0; r < reviewLinks.length; r++) {
        reviewLinks[r].addEventListener('click', scrollToReviews);
      }

      var prefix = root.getAttribute('data-money-prefix') || '$';
      var suffix = root.getAttribute('data-money-suffix') || '';
      var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;
      var addUrl = root.getAttribute('data-cart-add');
      var cartUrl = root.getAttribute('data-cart-url');

      var tiers = [];
      (root.getAttribute('data-tiers') || '').split(',').forEach(function (part) {
        var bits = part.split(':');
        var n = parseInt(bits[0], 10);
        var s = parseFloat(bits[1]);
        if (n > 0 && s >= 0) tiers.push({ n: n, save: Math.round(s * 100) });
      });
      tiers.sort(function (a, b) { return b.n - a.n; });
      var topTier = tiers.length ? tiers[0].n : 0;
      var topExtra = root.getAttribute('data-top-extra') || '';
      var topPct = parseFloat(root.getAttribute('data-top-pct')) || 0;

      // The saving the bag will give, worked out the way the discounts do it.
      // Kaching takes each tier's saving off every sleeve (Duo $4 = $2 a sleeve,
      // Trio $8 = $2.67 a sleeve, rounded down per sleeve). On the top tier
      // Kaching takes topPct off each sleeve and Shopify's Buy 6 Get 1 frees the
      // cheapest sleeve in every seven; the bag keeps whichever is larger.
      function bagSave(t) {
        if (!t) return 0;
        var prices = [];
        lines.forEach(function (l) {
          if (l.kind !== 'sleeve') return;
          for (var i = 0; i < l.qty; i++) prices.push(l.price);
        });
        if (topExtra && t.n === topTier) {
          var pct = 0, free = 0;
          prices.forEach(function (p) { pct += Math.floor(p * topPct / 100); });
          prices.sort(function (a, b) { return a - b; });
          for (var j = 0; j < Math.floor(prices.length / topTier); j++) free += prices[j];
          return Math.max(pct, free);
        }
        return Math.round(t.save / t.n) * prices.length;
      }

      // "7th", "3rd", and so on, so the nudge can name the free one.
      function ordinal(x) {
        var v = x % 100;
        if (v >= 11 && v <= 13) return x + 'th';
        return x + (['th', 'st', 'nd', 'rd'][x % 10] || 'th');
      }

      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
      // Only the sleeve grid is filtered by finish. Sets keep their own row.
      var gridCards = Array.prototype.slice.call(root.querySelectorAll('[data-grid] [data-card]'));
      var gridCells = gridCards.map(function (c) { return c.closest('.csb__cell') || c; });

      // One line per product (per print choice, for a set from the panel), each
      // with its own quantity. Only sleeves count toward Bundle & Save: sets are
      // not part of the Kaching deal.
      var lines = [];

      function each(sel, fn) {
        var list = root.querySelectorAll(sel);
        for (var i = 0; i < list.length; i++) fn(list[i]);
      }
      function money(cents) { return prefix + (cents / 100).toFixed(2) + suffix; }
      function find(key) { for (var i = 0; i < lines.length; i++) { if (lines[i].key === key) return lines[i]; } return null; }
      function qtyOf(handle) { return lines.reduce(function (a, l) { return a + (l.handle === handle ? l.qty : 0); }, 0); }
      function change(key, d) {
        var l = find(key);
        if (!l) return;
        l.qty += d;
        if (l.qty <= 0) lines.splice(lines.indexOf(l), 1);
        render();
      }

      function tierFor(n) {
        for (var i = 0; i < tiers.length; i++) { if (n >= tiers[i].n) return tiers[i]; }
        return null;
      }
      function nextTier(n) {
        for (var i = tiers.length - 1; i >= 0; i--) { if (n < tiers[i].n) return tiers[i]; }
        return null;
      }

      // The tiers are drawn in Liquid. Here they only light up as each is reached.
      function renderTiers(count) {
        each('[data-tier-n]', function (el) {
          el.classList.toggle('is-on', count >= parseInt(el.getAttribute('data-tier-n'), 10));
        });
      }

      function render() {
        var count = lines.reduce(function (a, l) { return a + l.qty; }, 0);
        var sleeves = lines.reduce(function (a, l) { return a + (l.kind === 'sleeve' ? l.qty : 0); }, 0);
        var sub = lines.reduce(function (a, l) { return a + l.price * l.qty; }, 0);
        var t = tierFor(sleeves);
        var save = bagSave(t);
        var total = Math.max(sub - save, 0);

        renderTiers(sleeves);

        each('[data-set]', function (set) {
          set.innerHTML = '';
          if (!count) {
            var p = document.createElement('p');
            p.className = 'csb__empty';
            p.textContent = root.getAttribute('data-empty') || 'Nothing chosen yet.';
            set.appendChild(p);
          }
          lines.forEach(function (l) {
            var row = document.createElement('div');
            row.className = 'csb__piece';
            row.innerHTML = '<img src="' + esc(l.img) + '" alt=""><span><span class="csb__piece-name">' + esc(l.name) + '</span>' +
              (l.desc ? '<span class="csb__piece-desc">' + esc(l.desc) + '</span>' : '') +
              '<span class="csb__piece-controls"></span></span><span class="csb__piece-price">' + money(l.price * l.qty) + '</span>';
            var controls = row.querySelector('.csb__piece-controls');
            if (l.std || l.slim) {
              if (l.fixedFit === undefined) {
                var sw = document.createElement('span');
                sw.className = 'csb__switch';
                ['STANDARD', 'SLIMLINE'].forEach(function (opt) {
                  var b = document.createElement('button');
                  b.type = 'button';
                  b.className = 'csb__switch-btn';
                  b.innerHTML = opt === 'STANDARD'
                    ? 'Standard<small>375 ml</small>'
                    : 'Slimline<small>250–330 ml</small>';
                  b.setAttribute('aria-pressed', String(l.fit === opt));
                  if ((opt === 'SLIMLINE' && !l.slim) || (opt === 'STANDARD' && !l.std)) b.disabled = true;
                  b.addEventListener('click', function () {
                    if (l.fit === opt) return;
                    l.fit = opt;
                    render();
                  });
                  sw.appendChild(b);
                });
                controls.appendChild(sw);
              }
            }
            var q = document.createElement('span');
            q.className = 'csb__qty';
            q.innerHTML = '<button type="button" aria-label="' + (l.qty === 1 ? 'Remove ' : 'One fewer ') + esc(l.name) + '">' + (l.qty === 1 ? '&times;' : '&minus;') + '</button>' +
              '<output aria-live="polite">' + l.qty + '</output>' +
              '<button type="button" aria-label="One more ' + esc(l.name) + '">+</button>';
            q.children[0].addEventListener('click', function () { change(l.key, -1); });
            q.children[2].addEventListener('click', function () { change(l.key, 1); });
            controls.appendChild(q);
            set.appendChild(row);
          });
        });

        cards.forEach(function (card) {
          var n = qtyOf(card.getAttribute('data-handle'));
          card.setAttribute('aria-pressed', String(n > 0));
          var pick = card.querySelector('.csb__pick');
          if (pick) pick.innerHTML = n ? (n > 1 ? String(n) : '&#10003;') : '+';
        });

        var countLabel = root.querySelector('[data-count-label]');
        countLabel.textContent = count ? count + (count === 1 ? ' piece' : ' pieces') : (countLabel.getAttribute('data-empty') || 'Nothing chosen');
        root.querySelector('[data-subtotal]').textContent = money(sub);
        root.querySelector('[data-save-row]').hidden = save === 0;
        var linesEl = root.querySelector('.csb__lines');
        if (linesEl) linesEl.hidden = !count;
        root.querySelector('[data-save-label]').textContent = t ? 'You save on any ' + t.n : 'You save';
        root.querySelector('[data-save-amt]').textContent = '-' + money(save);
        root.querySelector('[data-total]').textContent = money(total);

        // The nudge only ever talks about sleeves, as only sleeves earn the tiers.
        var nudgeText = '';
        if (sleeves) {
          var nx = nextTier(sleeves);
          if (nx) {
            var gap = nx.n - sleeves;
            var more = 'Add <b>' + gap + ' more ' + (gap === 1 ? 'sleeve' : 'sleeves') + '</b>';
            var toTop = topExtra && nx.n === topTier;
            if (toTop && (nx.save === 0 || (t && nx.save === t.save))) {
              nudgeText = more + ' and your <b>' + ordinal(topTier) + ' sleeve is free</b>.';
            } else {
              nudgeText = more + ' to save <b>' + money(nx.save) + '</b>' + (toTop ? ', and your <b>' + ordinal(topTier) + ' sleeve is free</b>.' : '.');
            }
          } else if (topExtra && sleeves >= topTier) {
            nudgeText = 'Best price reached. Your <b>' + ordinal(topTier) + ' sleeve is free</b>.';
          }
        }
        each('[data-nudge]', function (el) { el.innerHTML = nudgeText; });

        if (threshold > 0) {
          var shipText = total >= threshold ? 'Shipping is on us' : money(threshold - total) + ' to free shipping';
          each('[data-ship]', function (el) {
            el.textContent = shipText;
            el.classList.toggle('csb__ship--met', total >= threshold);
            el.style.display = (count > 0 && threshold - total <= 4000) ? '' : 'none';
          });
        }

        var label = count ? 'Add ' + count + (count === 1 ? ' piece' : ' pieces') + ' to bag' : root.getAttribute('data-idle');
        each('[data-add], [data-add-mobile]', function (b) { b.disabled = !count; b.textContent = label; });

        root.querySelector('[data-tray]').hidden = !count;
        root.querySelector('[data-tray-label]').textContent = count + (count === 1 ? ' piece' : ' pieces') + (save ? ', save ' + money(save) : '');
        root.querySelector('[data-tray-total]').textContent = money(total);
      }

      function addCard(card) {
        var key = card.getAttribute('data-handle');
        var l = find(key);
        if (l) l.qty += 1;
        else {
          var std = card.getAttribute('data-std');
          var slim = card.getAttribute('data-slim');
          lines.push({
            key: key,
            kind: card.getAttribute('data-kind') || 'sleeve',
            handle: key,
            name: card.getAttribute('data-name'),
            desc: card.getAttribute('data-desc'),
            price: parseInt(card.getAttribute('data-price'), 10) || 0,
            img: card.getAttribute('data-img'),
            std: std,
            slim: slim,
            fit: std ? 'STANDARD' : 'SLIMLINE',
            qty: 1
          });
        }
        render();
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () { addCard(card); });
      });

      function applyFilter(value) {
        gridCards.forEach(function (card, i) {
          var tags = ',' + (card.getAttribute('data-tags') || '') + ',';
          gridCells[i].hidden = !(value === 'all' || tags.indexOf(',' + value + ',') > -1);
        });
        Array.prototype.forEach.call(root.querySelectorAll('.csb__chip'), function (c) {
          c.setAttribute('aria-pressed', String(c.getAttribute('data-filter') === value));
        });
      }

      Array.prototype.forEach.call(root.querySelectorAll('[data-filter]'), function (b) {
        b.addEventListener('click', function () {
          applyFilter(b.getAttribute('data-filter'));
          // The finish panels' links sit well below the grid: take the shopper up to it.
          if (b.classList.contains('csb__finish-link')) {
            var to = root.querySelector('.csb__filters') || root.querySelector('[data-grid]');
            if (to) to.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      // ---- The set panel (After Dark) ----
      var panel = root.querySelector('[data-nc-panel]');
      var pick = {};
      var lastFocus = null;

      function steps() {
        return Array.prototype.map.call(panel.querySelectorAll('[data-nc-step]'), function (el) {
          return { group: el.getAttribute('data-nc-step'), prop: el.getAttribute('data-prop') };
        });
      }

      function paintPanel() {
        each('[data-nc-swatch]', function (sw) {
          var g = pick[sw.getAttribute('data-group')];
          sw.setAttribute('aria-pressed', String(!!g && g.value === sw.getAttribute('data-value')));
        });
        each('[data-nc-chosen]', function (el) {
          var g = pick[el.getAttribute('data-nc-chosen')];
          el.textContent = g ? g.label : '';
        });
        var btn = panel.querySelector('[data-nc-add]');
        var ready = steps().every(function (s) { return pick[s.group]; });
        btn.disabled = !ready;
        btn.textContent = btn.getAttribute(ready ? 'data-ready' : 'data-idle');
      }

      function openPanel() {
        pick = {};
        // Standard is the product page's default fit too.
        if (panel.querySelector('[data-nc-step="fit"]')) pick.fit = { value: 'Standard', label: 'Standard' };
        paintPanel();
        lastFocus = document.activeElement;
        panel.hidden = false;
        document.documentElement.classList.add('csb-lock');
        var x = panel.querySelector('.csb__nc-x');
        if (x) x.focus();
      }

      function closePanel() {
        if (panel.hidden) return;
        panel.hidden = true;
        document.documentElement.classList.remove('csb-lock');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      if (panel) {
        each('[data-open-picker]', function (el) {
          el.addEventListener('click', function (e) { e.preventDefault(); openPanel(); });
        });
        each('[data-nc-close]', function (el) { el.addEventListener('click', closePanel); });
        panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
        each('[data-nc-swatch]', function (sw) {
          sw.addEventListener('click', function () {
            pick[sw.getAttribute('data-group')] = { value: sw.getAttribute('data-value'), label: sw.getAttribute('data-label') };
            paintPanel();
          });
        });
        panel.querySelector('[data-nc-add]').addEventListener('click', function () {
          var st = steps();
          if (!st.every(function (s) { return pick[s.group]; })) return;
          var props = {};
          // Hidden fields the product page also sends, one "name=value" per line.
          (panel.getAttribute('data-hidden') || '').split(/\r?\n/).forEach(function (row) {
            var i = row.indexOf('=');
            if (i > 0) props[row.slice(0, i).trim()] = row.slice(i + 1).trim();
          });
          var prints = [];
          st.forEach(function (s) {
            props[s.prop] = pick[s.group].value;
            if (s.group !== 'fit') prints.push(title(pick[s.group].label));
          });
          var key = 'set|' + st.map(function (s) { return pick[s.group].value; }).join('|');
          var l = find(key);
          if (l) l.qty += 1;
          else lines.push({
            key: key,
            kind: 'set',
            handle: '',
            name: panel.getAttribute('data-name'),
            desc: prints.join(' · ') + (pick.fit ? ' · ' + pick.fit.label : ''),
            price: parseInt(panel.getAttribute('data-price'), 10) || 0,
            img: panel.getAttribute('data-img'),
            std: panel.getAttribute('data-variant'),
            slim: '',
            fit: 'STANDARD',
            fixedFit: true,
            qty: 1,
            props: props
          });
          closePanel();
          render();
        });
      }

      function addToCart() {
        var items = lines.map(function (l) {
          var id = l.fit === 'SLIMLINE' && l.slim ? l.slim : (l.std || l.slim);
          var item = { id: parseInt(id, 10), quantity: l.qty };
          if (l.props) item.properties = l.props;
          return item;
        }).filter(function (i) { return i.id; });
        if (!items.length) return;
        each('[data-add], [data-add-mobile]', function (b) { b.disabled = true; });
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = cartUrl;
        }).catch(function () {
          each('[data-add], [data-add-mobile]', function (b) { b.disabled = false; });
        });
      }

      var addBtn = root.querySelector('[data-add]');
      root.setAttribute('data-idle', addBtn ? addBtn.textContent.trim() : 'Add to bag');
      var cl = root.querySelector('[data-count-label]');
      if (cl) cl.setAttribute('data-empty', cl.textContent.trim());
      var empty = root.querySelector('.csb__empty');
      root.setAttribute('data-empty', empty ? empty.textContent.trim() : '');
      each('[data-add], [data-add-mobile]', function (b) { b.addEventListener('click', addToCart); });

      render();
    }

    function boot() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-csb]'), init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-csb]');
      if (el) { delete el.dataset.csbReady; init(el); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-sets-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REVIEW_TARGETS = [
      '#collection-review-carousel',
      '.jdgm-all-reviews-widget',
      '#judgeme_all_reviews_page',
      '.jdgm-rev-widget',
      '#judgeme_product_reviews',
      '.jdgm-widget'
    ];

    function scrollToReviews(e) {
      for (var i = 0; i < REVIEW_TARGETS.length; i++) {
        var el = document.querySelector(REVIEW_TARGETS[i]);
        if (el && el.offsetParent !== null) {
          e.preventDefault();
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
      }
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
    function title(s) { return String(s || '').replace(/(^|[\s(])([a-zà-ÿ])/g, function (m, a, c) { return a + c.toUpperCase(); }); }

    function init(root) {
      if (!root || root.dataset.cseReady) return;
      root.dataset.cseReady = '1';

      Array.prototype.forEach.call(root.querySelectorAll('[data-reviews-link]'), function (a) {
        a.addEventListener('click', scrollToReviews);
      });

      var prefix = root.getAttribute('data-money-prefix') || '$';
      var suffix = root.getAttribute('data-money-suffix') || '';
      var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;
      var addUrl = root.getAttribute('data-cart-add') || '/cart/add';
      var cartUrl = root.getAttribute('data-cart-url') || '/cart';
      var nudgeShip = root.getAttribute('data-nudge-ship') || '';
      var addedText = root.getAttribute('data-added-text') || '[set] is in your bag.';
      var tray = root.querySelector('[data-tray]');

      // Every set on the page, for the free shipping nudge.
      var offers = [];

      function each(sel, fn, scope) { Array.prototype.forEach.call((scope || root).querySelectorAll(sel), fn); }
      function money(cents) { return prefix + (cents / 100).toFixed(2) + suffix; }
      function moneyShort(cents) { return cents % 100 ? money(cents) : prefix + (cents / 100) + suffix; }

      // The bar reflects the real bag, so the meter counts everything in it.
      function showBag(cart, setName) {
        var total = cart.total_price || 0;
        var count = cart.item_count || 0;

        // One job for the nudge: name the least expensive set that takes the
        // bag to free shipping. It only ever suggests adding a whole set.
        var nudge = '';
        if (threshold > 0 && nudgeShip) {
          var need = threshold - total;
          if (need > 0) {
            var pick = null;
            offers.forEach(function (o) { if (o.price >= need && (!pick || o.price < pick.price)) pick = o; });
            if (pick) {
              nudge = esc(nudgeShip)
                .replace('[set]', '<b>' + esc(pick.name) + '</b>')
                .replace('[price]', moneyShort(pick.price));
            }
          }
        }
        each('[data-nudge]', function (el) { el.innerHTML = nudge; });

        if (threshold > 0) {
          var left = threshold - total;
          each('[data-ship]', function (el) {
            el.textContent = left <= 0 ? 'Shipping is on us' : money(left) + ' to free shipping';
            el.classList.toggle('cse__ship--met', left <= 0);
            var wrap = el.parentNode.classList.contains('cse__shipwrap') ? el.parentNode : el; wrap.style.display = (count > 0 && left <= 4000) ? '' : 'none';
          });
          var bar = root.querySelector('[data-bar]');
          if (bar) bar.style.width = Math.min(100, (total / threshold) * 100) + '%';
        }

        var added = root.querySelector('[data-tray-added]');
        if (added && setName) added.textContent = addedText.replace('[set]', setName);
        root.querySelector('[data-tray-label]').textContent = count + (count === 1 ? ' item' : ' items') + ' in your bag';
        root.querySelector('[data-tray-total]').textContent = money(total);
        tray.hidden = !count;
        // Keep the last of the page clear of the bar.
        root.style.paddingBottom = count ? (tray.offsetHeight + 24) + 'px' : '';
      }

      // Let the theme refresh its bag count and drawer.
      function tellTheme() {
        try {
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        } catch (e) {}
      }

      // ---- The sets: every choice box works the same way ----
      each('[data-setrow]', function (row) {
        var mode = row.getAttribute('data-mode');
        var img = row.querySelector('.cse__setimg');
        var note = row.querySelector('[data-added]');
        var btn = row.querySelector('[data-set-add]');
        var btnText = btn.textContent;
        var timer = null;

        offers.push({ name: row.getAttribute('data-name'), price: parseInt(row.getAttribute('data-price'), 10) || 0 });

        function chosen(box) { return box.querySelector('[data-opt][aria-checked="true"]'); }
        function fitOf() {
          var f = row.querySelector('[data-fit] [aria-pressed="true"]');
          return f ? f.getAttribute('data-value') : '';
        }
        function paint(box, picked) {
          var c = chosen(box);
          var out = box.querySelector('[data-chosen]');
          // The chosen name, with its print description underneath.
          if (out) {
            out.textContent = c ? title(c.getAttribute('data-label')) : '';
            var d = c && c.getAttribute('data-desc');
            if (d) {
              var small = document.createElement('small');
              small.textContent = d;
              out.appendChild(small);
            }
          }
          // The moment photo leads; once a print is picked, a one-print set
          // shows that print's product photo.
          if (picked && mode === 'prints' && c && img && c.getAttribute('data-img')) {
            img.removeAttribute('srcset');
            img.style.objectPosition = '';
            img.src = c.getAttribute('data-img');
          }
        }

        each('[data-choice]', function (box) {
          each('[data-opt]', function (chip) {
            chip.addEventListener('click', function () {
              each('[data-opt]', function (x) { x.setAttribute('aria-checked', String(x === chip)); }, box);
              paint(box, true);
            });
          }, box);
          paint(box);
        }, row);

        each('[data-fit]', function (box) {
          var out = box.querySelector('[data-chosen]');
          each('button', function (b) {
            b.addEventListener('click', function () {
              each('button', function (x) { x.setAttribute('aria-pressed', String(x === b)); }, box);
              if (out) out.textContent = b.getAttribute('data-value');
            });
          }, box);
          var on = box.querySelector('[aria-pressed="true"]');
          if (out && on) out.textContent = on.getAttribute('data-value');
        }, row);

        // Each set goes straight to the bag, with the same order fields as its product page.
        btn.addEventListener('click', function () {
          var name = row.getAttribute('data-name');
          var fit = fitOf();
          var item;
          if (mode === 'prints') {
            var c = chosen(row.querySelector('[data-choice="print"]'));
            if (!c) return;
            var std = c.getAttribute('data-std'), slim = c.getAttribute('data-slim');
            item = { id: parseInt(fit === 'Slimline' && slim ? slim : (std || slim), 10), quantity: 1 };
          } else {
            var props = {}, ok = true;
            each('[data-choice="step"]', function (box) {
              var s = chosen(box);
              if (!s) { ok = false; return; }
              props[box.getAttribute('data-prop')] = s.getAttribute('data-value');
            }, row);
            if (!ok) return;
            var fitBox = row.querySelector('[data-fit]');
            if (fitBox && fit) props[fitBox.getAttribute('data-prop')] = fit;
            (row.getAttribute('data-hidden') || '').split(/\r?\n/).forEach(function (pair) {
              var i = pair.indexOf('=');
              if (i > 0) props[pair.slice(0, i).trim()] = pair.slice(i + 1).trim();
            });
            item = { id: parseInt(row.getAttribute('data-variant'), 10), quantity: 1, properties: props };
          }
          if (!item.id) return;

          btn.disabled = true;
          btn.textContent = 'Adding…';
          fetch(addUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [item] })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } });
          }).then(function (r) { return r.json(); }).then(function (cart) {
            showBag(cart, name);
            tellTheme();
            btn.textContent = 'Added to bag';
            if (note) note.textContent = addedText.replace('[set]', name);
            clearTimeout(timer);
            timer = setTimeout(function () {
              btn.textContent = btnText;
              btn.disabled = false;
              if (note) note.textContent = '';
            }, 2400);
          }).catch(function () {
            btn.textContent = btnText;
            btn.disabled = false;
            if (note) note.textContent = 'That set could not be added. Please try again.';
          });
        });
      });
    }

    function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-cse]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-cse]');
      if (el) { delete el.dataset.cseReady; init(el); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tiles-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REVIEW_TARGETS = [
      '#collection-review-carousel',
      '.jdgm-all-reviews-widget',
      '#judgeme_all_reviews_page',
      '.jdgm-rev-widget',
      '#judgeme_product_reviews',
      '.jdgm-widget'
    ];

    function scrollToReviews(e) {
      for (var i = 0; i < REVIEW_TARGETS.length; i++) {
        var el = document.querySelector(REVIEW_TARGETS[i]);
        if (el && el.offsetParent !== null) {
          e.preventDefault();
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
      }
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
    function title(s) { return String(s || '').replace(/(^|[\s(])([a-zà-ÿ])/g, function (m, a, c) { return a + c.toUpperCase(); }); }

    function init(root) {
      if (!root || root.dataset.ctbReady) return;
      root.dataset.ctbReady = '1';

      Array.prototype.forEach.call(root.querySelectorAll('[data-reviews-link]'), function (a) {
        a.addEventListener('click', scrollToReviews);
      });

      var prefix = root.getAttribute('data-money-prefix') || '$';
      var suffix = root.getAttribute('data-money-suffix') || '';
      var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;
      var addUrl = root.getAttribute('data-cart-add');
      var cartUrl = root.getAttribute('data-cart-url');
      var tierN = parseInt(root.getAttribute('data-tier-n'), 10) || 0;
      var tierSave = parseInt(root.getAttribute('data-tier-save'), 10) || 0;
      var tierPrice = parseInt(root.getAttribute('data-tier-price'), 10) || 0;
      var deal = root.getAttribute('data-deal') || '';
      var nudgeMore = root.getAttribute('data-nudge-more') || '';
      var nudgeDone = root.getAttribute('data-nudge-done') || '';
      var tilePrefix = root.getAttribute('data-tile-prefix') || '';

      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));

      // One line per product and choice, each with its own quantity.
      // Only sets of Style Tiles count toward the Kaching deal; the bundled sets do not.
      var lines = [];

      function each(sel, fn, scope) { Array.prototype.forEach.call((scope || root).querySelectorAll(sel), fn); }
      function money(cents) { return prefix + (cents / 100).toFixed(2) + suffix; }
      function moneyShort(cents) { return cents % 100 ? money(cents) : prefix + (cents / 100) + suffix; }
      function find(key) { for (var i = 0; i < lines.length; i++) { if (lines[i].key === key) return lines[i]; } return null; }
      function add(line) {
        var l = find(line.key);
        if (l) l.qty += 1; else { line.qty = 1; lines.push(line); }
        render();
      }
      function change(key, d) {
        var l = find(key);
        if (!l) return;
        l.qty += d;
        if (l.qty <= 0) lines.splice(lines.indexOf(l), 1);
        render();
      }

      function render() {
        var tiles = 0, count = 0, sub = 0;
        lines.forEach(function (l) {
          count += l.qty;
          if (l.kind === 'tiles') tiles += l.qty;
          sub += l.price * l.qty;
        });
        var save = tierN && tiles >= tierN ? tierSave : 0;
        var total = Math.max(sub - save, 0);
        var word = function (n) { return n === 1 ? 'item' : 'items'; };

        each('[data-set]', function (set) {
          set.innerHTML = '';
          if (!count) {
            var p = document.createElement('p');
            p.className = 'ctb__empty';
            p.textContent = root.getAttribute('data-empty') || '';
            set.appendChild(p);
          }
          lines.forEach(function (l) {
            var row = document.createElement('div');
            row.className = 'ctb__piece';
            row.innerHTML = '<img src="' + esc(l.img) + '" alt=""><span><span class="ctb__piece-name">' + esc(l.name) + '</span>' +
              (l.desc ? '<span class="ctb__piece-desc">' + esc(l.desc) + '</span>' : '') +
              '<span class="ctb__qty"><button type="button" aria-label="' + (l.qty === 1 ? 'Remove ' : 'One fewer ') + esc(l.name) + '">' + (l.qty === 1 ? '&times;' : '&minus;') + '</button>' +
              '<output aria-live="polite">' + l.qty + '</output>' +
              '<button type="button" aria-label="One more ' + esc(l.name) + '">+</button></span></span>' +
              '<span class="ctb__piece-price">' + money(l.price * l.qty) + '</span>';
            var q = row.querySelectorAll('.ctb__qty button');
            q[0].addEventListener('click', function () { change(l.key, -1); });
            q[1].addEventListener('click', function () { change(l.key, 1); });
            set.appendChild(row);
          });
        });

        cards.forEach(function (card) {
          var l = find('tiles|' + card.getAttribute('data-handle'));
          var n = l ? l.qty : 0;
          card.setAttribute('aria-pressed', String(n > 0));
          card.querySelector('.ctb__pick').innerHTML = n ? (n > 1 ? String(n) : '&#10003;') : '+';
        });

        var linesEl = root.querySelector('.ctb__lines');
        if (linesEl) linesEl.hidden = !count;
        root.querySelector('[data-count-label]').textContent = count + ' ' + word(count);
        root.querySelector('[data-subtotal]').textContent = money(sub);
        root.querySelector('[data-save-row]').hidden = !save;
        root.querySelector('[data-save-amt]').textContent = '-' + money(save);
        root.querySelector('[data-total]').textContent = money(total);

        // One job for the nudge: reach the Style Tiles deal.
        var nudge = '';
        if (tierN && tiles > 0 && tiles < tierN && nudgeMore) {
          var more = tierN - tiles;
          nudge = esc(nudgeMore)
            .replace('[more]', '<b>' + more + ' more set' + (more > 1 ? 's' : '') + '</b>')
            .replace('[price]', '<b>' + moneyShort(tierPrice) + '</b>');
        } else if (save && nudgeDone) {
          nudge = esc(nudgeDone)
            .replace('[deal]', '<b>' + esc(deal) + '</b>')
            .replace('[save]', money(save));
        }
        each('[data-nudge]', function (el) { el.innerHTML = nudge; });

        if (threshold > 0) {
          var left = threshold - total;
          var shipText = left <= 0 ? 'Shipping is on us' : money(left) + ' to free shipping';
          each('[data-ship]', function (el) {
            el.textContent = shipText;
            el.classList.toggle('ctb__ship--met', left <= 0);
            var wrap = el.parentNode.classList.contains('ctb__shipwrap') ? el.parentNode : el; wrap.style.display = (count > 0 && left <= 4000) ? '' : 'none';
          });
          var bar = root.querySelector('[data-bar]');
          if (bar) bar.style.width = Math.min(100, (total / threshold) * 100) + '%';
        }

        var label = count ? 'Add ' + count + ' ' + word(count) + ' to bag' : root.getAttribute('data-idle');
        each('[data-add], [data-add-mobile]', function (b) { b.disabled = !count; b.textContent = label; });

        root.querySelector('[data-tray]').hidden = !count;
        root.querySelector('[data-tray-label]').textContent = count + ' ' + word(count);
        root.querySelector('[data-tray-total]').textContent = money(total);

        each('[data-tier]', function (el) { el.classList.toggle('is-on', tierN > 0 && tiles >= tierN); });
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          add({
            key: 'tiles|' + card.getAttribute('data-handle'),
            kind: 'tiles',
            name: tilePrefix + title(card.getAttribute('data-name')),
            desc: card.getAttribute('data-desc'),
            price: parseInt(card.getAttribute('data-price'), 10) || 0,
            img: card.getAttribute('data-img'),
            id: card.getAttribute('data-variant')
          });
        });
      });

      // ---- The sets: every choice box works the same way ----
      each('[data-setrow]', function (row) {
        var mode = row.getAttribute('data-mode');
        var img = row.querySelector('.ctb__setimg');
        var note = row.querySelector('[data-added]');
        var timer = null;

        function chosen(box) { return box.querySelector('[data-opt][aria-checked="true"]'); }
        function fitOf() {
          var f = row.querySelector('[data-fit] [aria-pressed="true"]');
          return f ? f.getAttribute('data-value') : '';
        }
        function paint(box) {
          var c = chosen(box);
          var out = box.querySelector('[data-chosen]');
          if (out) out.textContent = c ? title(c.getAttribute('data-label')) : '';
          // A one-print set shows the chosen print's photo.
          if (mode === 'prints' && c && img && c.getAttribute('data-img')) {
            img.removeAttribute('srcset');
            img.src = c.getAttribute('data-img');
          }
        }

        each('[data-choice]', function (box) {
          each('[data-opt]', function (chip) {
            chip.addEventListener('click', function () {
              each('[data-opt]', function (x) { x.setAttribute('aria-checked', String(x === chip)); }, box);
              paint(box);
            });
          }, box);
          paint(box);
        }, row);

        each('[data-fit]', function (box) {
          var out = box.querySelector('[data-chosen]');
          each('button', function (b) {
            b.addEventListener('click', function () {
              each('button', function (x) { x.setAttribute('aria-pressed', String(x === b)); }, box);
              if (out) out.textContent = b.getAttribute('data-value');
            });
          }, box);
          var on = box.querySelector('[aria-pressed="true"]');
          if (out && on) out.textContent = on.getAttribute('data-value');
        }, row);

        row.querySelector('[data-set-add]').addEventListener('click', function () {
          var name = row.getAttribute('data-name');
          var price = parseInt(row.getAttribute('data-price'), 10) || 0;
          var fit = fitOf();
          var line;
          if (mode === 'prints') {
            var c = chosen(row.querySelector('[data-choice="print"]'));
            if (!c) return;
            var std = c.getAttribute('data-std'), slim = c.getAttribute('data-slim');
            line = {
              key: 'set|' + c.getAttribute('data-handle') + '|' + fit,
              kind: 'set',
              name: name,
              desc: title(c.getAttribute('data-label')) + (fit ? ' · ' + fit + ' fit' : ''),
              price: price,
              img: c.getAttribute('data-thumb'),
              id: fit === 'Slimline' && slim ? slim : (std || slim)
            };
          } else {
            var props = {}, labels = [], ok = true;
            each('[data-choice="step"]', function (box) {
              var c = chosen(box);
              if (!c) { ok = false; return; }
              props[box.getAttribute('data-prop')] = c.getAttribute('data-value');
              labels.push(title(c.getAttribute('data-label')));
            }, row);
            if (!ok) return;
            var fitBox = row.querySelector('[data-fit]');
            if (fitBox && fit) props[fitBox.getAttribute('data-prop')] = fit;
            (row.getAttribute('data-hidden') || '').split(/\r?\n/).forEach(function (pair) {
              var i = pair.indexOf('=');
              if (i > 0) props[pair.slice(0, i).trim()] = pair.slice(i + 1).trim();
            });
            line = {
              key: 'set|' + row.id + '|' + JSON.stringify(props),
              kind: 'set',
              name: name,
              desc: labels.join(' · ') + (fit ? ' · ' + fit + ' fit' : ''),
              price: price,
              img: row.getAttribute('data-thumb'),
              id: row.getAttribute('data-variant'),
              props: props
            };
          }
          if (!line.id) return;
          add(line);
          if (note) {
            note.textContent = root.getAttribute('data-added-text') || 'Added to your selection';
            clearTimeout(timer);
            timer = setTimeout(function () { note.textContent = ''; }, 2400);
          }
        });
      });

      function addToCart() {
        var items = lines.map(function (l) {
          var item = { id: parseInt(l.id, 10), quantity: l.qty };
          if (l.props) item.properties = l.props;
          return item;
        }).filter(function (i) { return i.id; });
        if (!items.length) return;
        each('[data-add], [data-add-mobile]', function (b) { b.disabled = true; });
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = cartUrl;
        }).catch(function () {
          each('[data-add], [data-add-mobile]', function (b) { b.disabled = false; });
        });
      }

      var addBtn = root.querySelector('[data-add]');
      root.setAttribute('data-idle', addBtn ? addBtn.textContent.trim() : 'Add to bag');
      var empty = root.querySelector('.ctb__empty');
      root.setAttribute('data-empty', empty ? empty.textContent.trim() : '');
      each('[data-add], [data-add-mobile]', function (b) { b.addEventListener('click', addToCart); });

      render();
    }

    function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-ctb]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-ctb]');
      if (el) { delete el.dataset.ctbReady; init(el); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-look"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function solidHeader() {
      if (!document.querySelector('[data-shop-by-look]')) return;
      var wrap = document.querySelector('.header-wrapper');
      if (wrap) wrap.classList.remove('header-wrapper--sticky', 'is-light');
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', solidHeader);
    } else {
      solidHeader();
    }

    document.addEventListener('shopify:section:load', solidHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.ShopTheLook) return;

    var THOUSANDS = /\B(?=(\d{3})+(?!\d))/g;

    function formatMoney(cents, format) {
      var amount = (Number(cents) || 0) / 100;
      if (!format) return '$' + amount.toFixed(2);
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
        if (key === 'amount_no_decimals') return Math.round(amount).toString().replace(THOUSANDS, ',');
        if (key === 'amount_with_comma_separator') return amount.toFixed(2).replace('.', ',');
        if (key === 'amount_no_decimals_with_comma_separator') return Math.round(amount).toString().replace(THOUSANDS, '.');
        return amount.toFixed(2).replace(THOUSANDS, ',');
      });
    }

    function parseTiers(text) {
      return String(text || '').split(',').map(function (pair) {
        var bits = pair.split(':');
        return { qty: parseInt(bits[0], 10), save: Math.round(parseFloat(bits[1]) * 100) };
      }).filter(function (tier) { return tier.qty > 0 && tier.save > 0; });
    }

    function init(root) {
      if (!root || root.dataset.stlReady) return;
      root.dataset.stlReady = 'true';

      var fmt = root.dataset.moneyFormat;
      var threshold = parseInt(root.dataset.threshold, 10) || 0;
      var deals = {};
      try { deals = JSON.parse(root.querySelector('[data-deals]').textContent); } catch (e) { deals = {}; }
      Object.keys(deals).forEach(function (key) { deals[key].tiers = parseTiers(deals[key].tiers); });

      var pieces = Array.prototype.map.call(root.querySelectorAll('[data-piece]'), function (el) {
        var variants = [];
        try { variants = JSON.parse(el.querySelector('[data-variants]').textContent); } catch (e) { variants = []; }
        return {
          el: el,
          id: el.dataset.block,
          variants: variants,
          check: el.querySelector('.stl__check'),
          deal: el.dataset.deal,
          qty: parseInt(el.dataset.qty, 10) || 1,
          max: parseInt(el.dataset.max, 10) || 10,
          variant: null
        };
      });

      var addButtons = root.querySelectorAll('[data-add]');
      var busy = false;

      function currentVariant(piece) {
        var sets = piece.el.querySelectorAll('.stl__opt');
        if (!sets.length) return piece.variants[0] || null;
        var chosen = Array.prototype.map.call(sets, function (set) {
          var input = set.querySelector('input:checked');
          return input ? input.value : null;
        });
        return piece.variants.find(function (variant) {
          return chosen.every(function (value, i) { return variant.options[i] === value; });
        }) || null;
      }

      function update() {
        var subtotal = 0;
        var total = 0;
        var count = 0;
        var dealTotals = {};

        pieces.forEach(function (piece) {
          var variant = currentVariant(piece);
          var available = !!(variant && variant.available);
          piece.variant = variant;
          piece.on = available && piece.check.checked;
          piece.line = variant ? variant.price * piece.qty : 0;
          piece.check.disabled = !available;
          piece.el.classList.toggle('is-off', !piece.on);

          var soldout = piece.el.querySelector('[data-soldout]');
          if (soldout) soldout.hidden = available;

          piece.el.querySelector('[data-qty-value]').textContent = piece.qty;
          piece.el.querySelector('[data-step="-1"]').disabled = piece.qty <= 1;
          piece.el.querySelector('[data-step="1"]').disabled = piece.qty >= piece.max;

          if (piece.on && piece.deal && piece.deal !== 'none') {
            var bucket = dealTotals[piece.deal] || (dealTotals[piece.deal] = { qty: 0, cents: 0 });
            bucket.qty += piece.qty;
            bucket.cents += piece.line;
          }
        });

        // Best tier per deal, then spread each saving across its pieces and round per unit, the way the bag does.
        var dealSavings = {};
        Object.keys(dealTotals).forEach(function (key) {
          var best = 0;
          if (deals[key]) deals[key].tiers.forEach(function (tier) { if (dealTotals[key].qty >= tier.qty && tier.save > best) best = tier.save; });
          dealSavings[key] = best;
        });

        pieces.forEach(function (piece) {
          var discounted = piece.line;
          var saving = piece.on ? (dealSavings[piece.deal] || 0) : 0;
          if (saving && dealTotals[piece.deal].cents) {
            var share = piece.line - saving * piece.line / dealTotals[piece.deal].cents;
            discounted = Math.round(share / piece.qty) * piece.qty;
          }

          piece.el.querySelector('[data-line-price]').textContent = formatMoney(discounted, fmt);
          var compare = piece.el.querySelector('[data-line-compare]');
          compare.hidden = discounted >= piece.line;
          compare.textContent = formatMoney(piece.line, fmt);

          if (piece.on) {
            subtotal += piece.line;
            total += discounted;
            count += 1;
          }
        });

        var saved = subtotal - total;
        root.querySelector('[data-total]').textContent = formatMoney(total, fmt);
        var was = root.querySelector('[data-subtotal]');
        was.hidden = saved <= 0;
        was.textContent = formatMoney(subtotal, fmt);
        var save = root.querySelector('[data-save]');
        save.hidden = saved <= 0;
        save.textContent = 'Save ' + formatMoney(saved, fmt);
        var savingsNote = root.querySelector('[data-savings-note]');
        if (savingsNote) savingsNote.hidden = saved <= 0;

        var placement = root.querySelector('square-placement');
        if (placement) placement.setAttribute('data-amount', (total / 100).toFixed(2));
        var afterpayWrap = root.querySelector('[data-afterpay-wrap]');
        if (afterpayWrap) afterpayWrap.hidden = count === 0;

        var shipText = root.querySelector('[data-ship-text]');
        if (shipText && threshold) {
          var remaining = threshold - total;
          shipText.textContent = remaining <= 0 ? 'Free shipping unlocked' : formatMoney(remaining, fmt) + ' away from free shipping';
        }

        var label;
        if (count === 0) label = root.dataset.labelNone;
        else if (count === pieces.length) label = root.dataset.labelAll;
        else label = root.dataset.labelSome.replace('[count]', count);
        if (count === 1) label = label.replace('pieces', 'piece');
        if (!busy) {
          Array.prototype.forEach.call(addButtons, function (button) {
            button.textContent = label;
            button.disabled = count === 0;
          });
        }

        var mbarLabel = root.querySelector('[data-mbar-label]');
        if (mbarLabel) {
          mbarLabel.textContent = count === pieces.length && pieces.length > 1 ? root.dataset.labelMobileAll : count + (count === 1 ? ' piece' : ' pieces');
          root.querySelector('[data-mbar-total]').textContent = formatMoney(total, fmt);
        }
      }

      function highlight(id) {
        Array.prototype.forEach.call(root.querySelectorAll('[data-spot]'), function (spot) { spot.classList.toggle('is-active', spot.dataset.spot === id); });
        pieces.forEach(function (piece) { piece.el.classList.toggle('is-active', piece.id === id); });
      }

      function setBusy(state) {
        busy = state;
        Array.prototype.forEach.call(addButtons, function (button) {
          button.disabled = state;
          if (state) button.textContent = 'Adding…';
        });
        if (!state) update();
      }

      function addToCart() {
        var items = pieces.filter(function (piece) {
          return piece.check.checked && piece.variant && piece.variant.available;
        }).map(function (piece) {
          return { id: piece.variant.id, quantity: piece.qty };
        });
        if (!items.length || busy) return;

        var errorEl = root.querySelector('[data-error]');
        errorEl.hidden = true;
        setBusy(true);

        fetch(root.dataset.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            return response.json().then(function (data) { return { ok: response.ok, data: data }; });
          })
          .then(function (result) {
            if (!result.ok) {
              var error = new Error(result.data.description || result.data.message || '');
              error.fromShop = true;
              throw error;
            }
            window.location.href = root.dataset.cartUrl;
          })
          .catch(function (error) {
            errorEl.textContent = error.fromShop && error.message
              ? error.message
              : 'We couldn’t add these pieces. Check your connection and try again.';
            errorEl.hidden = false;
            setBusy(false);
          });
      }

      root.addEventListener('change', function (event) {
        if (event.target.closest('[data-piece]')) update();
      });

      root.addEventListener('click', function (event) {
        var step = event.target.closest('[data-step]');
        if (step) {
          var piece = pieces.find(function (p) { return p.el.contains(step); });
          if (piece) {
            piece.qty = Math.min(Math.max(piece.qty + parseInt(step.dataset.step, 10), 1), piece.max);
            update();
          }
          return;
        }

        var spot = event.target.closest('[data-spot]');
        if (spot) {
          highlight(spot.dataset.spot);
          var card = root.querySelector('#stl-row-' + spot.dataset.spot);
          if (card) {
            var rect = card.getBoundingClientRect();
            if (rect.top < 0 || rect.bottom > window.innerHeight - 90) {
              var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
            }
          }
          return;
        }

        if (event.target.closest('[data-add]')) addToCart();
      });

      pieces.forEach(function (piece) {
        piece.el.addEventListener('pointerenter', function (event) { if (event.pointerType === 'mouse') highlight(piece.id); });
        piece.el.addEventListener('pointerleave', function (event) { if (event.pointerType === 'mouse') highlight(null); });
      });

      var mbar = root.querySelector('[data-mbar]');
      var mainButton = root.querySelector('.stl__cta [data-add]');
      if (mbar && mainButton && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          mbar.hidden = entries[0].isIntersecting;
        }).observe(mainButton);
      }

      root._stl = { highlight: highlight };
      update();
    }

    // Impulse gives this template an overlapping transparent header. Look pages want the
    // solid header the other collection pages have, so drop those two classes.
    function solidHeader() {
      if (!document.querySelector('[data-shop-the-look]')) return;
      var wrap = document.querySelector('.header-wrapper');
      if (wrap) wrap.classList.remove('header-wrapper--sticky', 'is-light');
    }

    function boot() {
      solidHeader();
      Array.prototype.forEach.call(document.querySelectorAll('[data-shop-the-look]'), init);
    }

    window.ShopTheLook = { init: init };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target.querySelector('[data-shop-the-look]'));
    });

    document.addEventListener('shopify:block:select', function (event) {
      var card = event.target.closest ? event.target.closest('[data-piece]') : null;
      var root = card ? card.closest('[data-shop-the-look]') : null;
      if (root && root._stl) root._stl.highlight(card.dataset.block);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
